module.exports = __webpack_public_path__ + "logo-anfr-reclamation.db59653a84a7deec4da9e7b731d1dc3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/base/components/header/logo-anfr-reclamation.png
// module id = 275
// module chunks = 0